export { FunnelChart } from './FunnelChart';
